module.exports = __webpack_public_path__ + "static/media/vertex-7002x-m.772c0934.jpg";